import PageHeader from "../../components/layout/PageHeader.jsx";
import SavedNotice from "../../components/common/SavedNotice";
import NextStepContainer from "../../components/common/NextStepContainer.jsx";
import PreviousStepContainer from "../../components/common/PreviousStepContainer";
import MechanismManager from "../../components/impactStrategy/MechanismManager.jsx";

/**
 * Route wrapper for Werkzame mechanismen. The CRUD lives in <MechanismManager>
 * (reused inline in the TOC navigator); this page adds the chrome.
 */
const TocMechanisms = () => {
  return (
    <div className="main">
      <div className="main-container">
        <PageHeader
          heading={"Werkzame mechanismen"}
          description={`Een werkzaam mechanisme beschrijft wáárom je activiteiten werken — de onderliggende manier waarop verandering ontstaat. Kies per mechanisme een categorie en koppel het aan de activiteiten waarin het zit en de effecten die het oplevert.`}
          AI={true}
        />
        <MechanismManager />

        <div className="impactstrategy-saved-and-nextstep-container">
          <SavedNotice />
          <div id="next-step-container">
            <PreviousStepContainer url={"Activities"} mainItem={"impactstrategy"} />
            <NextStepContainer url={"effects"} mainItem={"impactstrategy"} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default TocMechanisms;
